import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "@core-services/state.service";
import { CashPlusPortfolioApi } from "@modules/cashplus/entities/cashplus.model";

export interface CashPlusPortfolioState {
	fiatConfigs: CashPlusPortfolioApi[];
	error: boolean;
	isFundReleasePending: boolean;
}

const initialState: CashPlusPortfolioState | null = null;

@Injectable({
	providedIn: "root"
})
export class CashPlusPortfolioStateService extends StateService<CashPlusPortfolioState> {
	public constructor() {
		super(initialState);
	}

	public getState$(): Observable<CashPlusPortfolioState> {
		return this.select((state) => state);
	}

	public updateState(model: Partial<CashPlusPortfolioState>): void {
		this.setState(model);
	}

	public isPortfolioLoaded(): boolean {
		return this.isStateLoaded();
	}
}
